import { render } from "./ReceiveRule.vue?vue&type=template&id=5d4a5c31&scoped=true"
import script from "./ReceiveRule.vue?vue&type=script&lang=js"
export * from "./ReceiveRule.vue?vue&type=script&lang=js"

import "./ReceiveRule.vue?vue&type=style&index=0&id=5d4a5c31&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4a5c31"]])

export default __exports__